import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{background:'#052e1c',color:'rgba(255,255,255,0.7)',padding:'48px 0 24px'}}>
      <div className="container">
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))',gap:32,marginBottom:40}}>
          <div>
            <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:14}}>
              <div style={{width:30,height:30,borderRadius:8,background:'linear-gradient(135deg,#22c97f,#0d6e4f)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
                </svg>
              </div>
              <span style={{fontWeight:800,fontSize:'1rem',color:'#fff'}}>Budget<span style={{color:'#22c97f'}}>Tutor</span></span>
            </div>
            <p style={{fontSize:'0.82rem',lineHeight:1.6,color:'rgba(255,255,255,0.5)',margin:0}}>
              Affordable, quality tutoring for every family. UK & US.
            </p>
          </div>
          <div>
            <p style={{fontWeight:700,fontSize:'0.78rem',letterSpacing:'0.08em',textTransform:'uppercase',color:'rgba(255,255,255,0.35)',marginBottom:12}}>Platform</p>
            {[['Find a Tutor','/find-tutors'],['How It Works','/how-it-works'],['Become a Tutor','/become-a-tutor']].map(([l,h])=>(
              <Link key={h} to={h} style={{display:'block',color:'rgba(255,255,255,0.65)',fontSize:'0.875rem',marginBottom:8,textDecoration:'none'}}>{l}</Link>
            ))}
          </div>
          <div>
            <p style={{fontWeight:700,fontSize:'0.78rem',letterSpacing:'0.08em',textTransform:'uppercase',color:'rgba(255,255,255,0.35)',marginBottom:12}}>Legal</p>
            {[['Terms of Service','/terms'],['Privacy Policy','/privacy']].map(([l,h])=>(
              <Link key={h} to={h} style={{display:'block',color:'rgba(255,255,255,0.65)',fontSize:'0.875rem',marginBottom:8,textDecoration:'none'}}>{l}</Link>
            ))}
          </div>
          <div>
            <p style={{fontWeight:700,fontSize:'0.78rem',letterSpacing:'0.08em',textTransform:'uppercase',color:'rgba(255,255,255,0.35)',marginBottom:12}}>Pricing</p>
            <p style={{fontSize:'0.875rem',color:'rgba(255,255,255,0.65)',lineHeight:1.6,margin:0}}>
              From <strong style={{color:'#22c97f'}}>£8/hr</strong> · $10/hr<br/>
              No hidden fees. Ever.
            </p>
          </div>
        </div>
        <div style={{borderTop:'1px solid rgba(255,255,255,0.08)',paddingTop:20,display:'flex',justifyContent:'space-between',flexWrap:'wrap',gap:12}}>
          <p style={{fontSize:'0.78rem',color:'rgba(255,255,255,0.3)',margin:0}}>© {new Date().getFullYear()} BudgetTutor. All rights reserved.</p>
          <p style={{fontSize:'0.78rem',color:'rgba(255,255,255,0.3)',margin:0}}>UK & US · GBP & USD</p>
        </div>
      </div>
    </footer>
  );
}
